export default "__VITE_ASSET__B5Z3asoE__"